import axios from 'axios';
import { useAppState } from '../redux';
import { useMutation, useQueryClient } from 'react-query';
import { QueryKeys } from '../../constants/query-keys';

type RunTheRulesOptions = {
  onMutate: () => void
}

export const useRunTheRules = (options?: RunTheRulesOptions) => {
  const { session: { masterAccountId } } = useAppState()
  const queryClient = useQueryClient()

  const handleMutate = options?.onMutate ? options.onMutate : () => undefined
 
  const runRules = async (id: string | number | undefined): Promise<any> => {
    if (!id) return
    const response = await axios.get(`/cms/api/accounts/${masterAccountId}/global-job-pricing/versions/${id}/run`);

    // return response
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(response)
      }, 2000)
    })
  }

  const mutation = useMutation(runRules, {
    onMutate: (id) => {
      handleMutate()
      queryClient.invalidateQueries([QueryKeys.GLO_JAM_PRICING_VERSION, { id: id?.toString() }])
    },
    onSettled: (_, __, id) => {
      queryClient.invalidateQueries([QueryKeys.GLO_JAM_REVIEW_MATCHES, { id: id?.toString() }])
      queryClient.invalidateQueries([QueryKeys.GLO_JAM_PRICING_VERSION, { id: id?.toString() }])
    }
  })

  return mutation
}
